import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";

import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import { useSelectedBookmarkSelector, useUserActions } from "store";
import { IBookmark } from "store/types";

import { GroupItem } from "./GroupItem";

export const DataOperationsBookmark: React.FC<IBookmark> = ({
  params,
  name,
  id,
  is_default,
  is_private,
  account_default,
  user,
  type
}) => {
  const { push } = useHistory();
  const selectedBookmark = useSelectedBookmarkSelector();
  const { setSelectedBookmark } = useUserActions();

  const handleClick = useCallback(() => {
    setSelectedBookmark(id);
    push(params);
  }, [params, id, push, setSelectedBookmark]);

  return (
    <GroupItem
      icon={
        <MaterialTooltip isShow placement="top" title="Data Operations">
          <BarChartOutlinedIcon sx={{ fontSize: "18px" }} />
        </MaterialTooltip>
      }
      id={id}
      title={name}
      ownerData={user}
      isActive={selectedBookmark === id}
      onClick={handleClick}
      allowSetDefault
      isDefault={is_default}
      isPrivate={is_private}
      isAccountDefault={account_default}
      bookmarkType={type}
    />
  );
};
